<form [formGroup]="labourRatesFilterForm" class="filter-form-vertical">
  <div class="form-content">
    <div>
      <app-aems-multiline-tag-input
        label="Shop Code"
        formControlName="shopCode"
        placeholder="Enter Shop Code"
        [regex]="shopCodeRegex"></app-aems-multiline-tag-input>
    </div>
    <div>
      <mc-multi-select
        label="Equipment Type"
        fit="medium"
        width="100"
        placeholder="Select Equipment Type"
        ngDefaultControl
        formControlName="equipmentType">
        @for (equipmentType of equipmentTypeOptions; track equipmentType.code) {
          <mc-option [attr.data-cy]="equipmentType.code" [value]="equipmentType">{{ equipmentType.description }}</mc-option>
        }
      </mc-multi-select>
    </div>
    <!-- EXPIRY DATE & EFFECTIVE DATE FILTERS -->
    <div>
      <app-date-filter-row
        [formGroup]="labourRatesFilterForm"
        label="Expiry Date"
        typeControlName="expiryDateType"
        dateControlName="expiryDate"
        fromControlName="expiryDateFrom"
        toControlName="expiryDateTo"
        [options]="expiryDateTypes">
      </app-date-filter-row>

      <app-date-filter-row
        style="display: block; margin-top: 16px"
        [formGroup]="labourRatesFilterForm"
        label="Effective Date"
        typeControlName="effectiveDateType"
        dateControlName="effectiveDate"
        fromControlName="effectiveDateFrom"
        toControlName="effectiveDateTo"
        [options]="effectiveDateTypes">
      </app-date-filter-row>
    </div>
  </div>
  <div class="pure-u-md-24-24 utility-buttons">
    <mc-button
      label="Apply filters"
      slot="primaryAction"
      variant="filled"
      appearance="primary"
      fit="medium"
      (click)="applyFilters()"
      class="p-r-16"></mc-button>
    <mc-button
      label="Clear filters"
      slot="secondaryAction"
      appearance="neutral"
      fit="medium"
      (click)="clearFilters()"
      class="p-r-16"></mc-button>
  </div>
</form>
